// extracted by mini-css-extract-plugin
export var fullGrid = "_3f-3";
export var pdpPreviewContainer = "_3f-1";
export var previewContainer = "_3f-0";
export var togglePreviewContainer = "_3f-2";